<span
  class="screen-reader-only"
  *ngIf="
    (!configuration?.highContrast || !configuration?.screenReaderFriendly) &&
    !haspath
  "
  role="alert"
>
  To navigate through the accessible mode of the simulation please enable screen
  reader mode and high contrast mode from the hamburger menu present in header
  section. Both the modes can be enabled together or individually one by one
  also.
</span>
<app-topmenu
  [courseName]="configuration?.courseName"
  [menu]="configuration?.menu"
  [nextDecision]="nextDecision"
></app-topmenu>
<app-header [pageName]="title" [data]="subMenu"></app-header>
<div class="container" id="main-content">
  <app-submenu [data]="subMenu" [isWhiteLine]="false"></app-submenu>
</div>
<div class="container">
  <app-zonepanel [zones]="zones"></app-zonepanel>
</div>
<app-dialog></app-dialog>
<app-demodialog
  #dialog
  [data]="demoparameters"
  *ngIf="demoparameters?.userPilotScriptId == null"
></app-demodialog>
<app-footer></app-footer>
<app-needhelp-button [token]="token" *ngIf="token"></app-needhelp-button>
